import plausible from 'plausible-tracker'

const tracker = plausible({
    domain: 'schwarzschild.design'
});

tracker.trackPageview();
tracker.enableAutoPageviews();
